const palette = {
  white: '#FFFFFF',
  grey: {
    100: '#F8F8F8',
    200: '#F2F2F2',
    300: '#F7F7F7',
    400: '#999999',
    500: '#666666',
    600: '#CCCCCC',
    700: '#828282',
    800: '#F8F8F8',
    900: '#F2F2F2',
    1000: '#FBFBFB',
    1100: '#F0F0F0',
    1200: '#EBECEC',
    1300: '#F1EFF6',
    1400: '#67A7FE',
    1500: '#A094EA',
    1600: '#8AE3F5',
    1700: '#FED367',
    1800: '#FFB366',
    1900: '#FF99C1',
    2000: '#A1D194',
    2100: '#EF7676',
    2200: '#333333',
    2300: '#f5f5f5',
    2400: '#FBFAF9',
    2500: '#D2D6DB',
    2600: '#444444',
    2700: '#F7F5F2'
  },
  black: '#2F2F2F',
  blue: {
    100: '#4E67F3',
    200: '#1A38D5',
    300: '#67A7FE',
    400: '#3D55FF',
    500: '#CCE2FF',
    600: '#F0F6FF',
    700: '#1F7EFE',
    800: '#402E7A',
    900: '#344955',
    1000: '#082032',
    1100: '#4f1787',
    1200: '#3F3351',
    1300: '#366EE9'
  },
  green: {
    100: '#56CF84',
    200: '#4AA785',
    300: '#79C897',
    400: '#11998E',
    500: '#34C1B6',
    600: '#70B38F'
  },
  red: { 100: '#E62424', 200: '#EA4242', 300: '#FF1F1F'},
  purple: { 100: '#B173B1', 200: '#F4F2FD', 300: '#5843DA', 400: '#7453DE', 500: '#A15AD1' },
  pink: { 100:'#E216A5' },
  orange: { 100: '#F6977A' },
  yellow: { 100: '#FFF0CC', 200: '#FFFBF0', 300:'#CA9202' },
  brown: { 100: '#C89CA2' },
  backgrounds: { 100: '#FFF6FC', 200: '#FEF5F2', 300: '#FDFAFB', 400: '#FCF7FF' },



  // everything below this line is deprecated and should not be used,
  // only to be removed while working on the new design system.
  components: {
    white: '#fff',
    background: { blue: '#4E67F3', grey: '#F4F6F8', black: '#2F2F2F' }
  },
  home: {
    button: '#F4F4F4',
    event: '#C6C6C6'
  },
  input: { grey: '#F7F7F7' },
  border: { grey: '#DDDFE4' },
  calendar: { background: '#FBFBFB', event: { background: '#F2F2F2' } },
  title: { grey: '#999999' },
  button: {
    save: { active: '#2F2F2F', disabled: '#828282' },
    cancel: { background: '#d8d9d9' },
    text: { blue: '#1A38D5' },
    delete: '#E62424',
    status: { done: '#4E66F2' }
  },
  avatar: '#F2F2F2',
  typography: {
    black: '#2f2f2f',
    white: '#fff',
    grey: '#666',
    placeholder: '#CCC',
    blue: '#1F7EFE'
  },
  menu: {
    item: '#656565'
  },
  common: {
    background: {
      grey: '#F8F8F8',
      darkGrey: '#828282'
    },
    white: '#fff',
    label: '#666',
    color: {
      grey1: '#666666',
      grey2: '#CCCCCC'
    },
    stripe: '#CCC'
  },
  stroke: {
    idle: '#DDDFE4',
    subtle: '#F7F7F7'
  },
  globalBackground: '#FBFAF9'
};

export default palette;
